import { WorkoutExercise } from '@src/data/workout-exercise'
import { ScreensaverDTO } from '@src/dto/screensaver-dto'
import { DEFAULT_SCREENSAVER_IMAGE, SUPPORTED_VIDEO_TYPES } from '@src/util/constants'

export const DEFAULT_SCREENSAVER: ScreensaverDTO = {
  content: DEFAULT_SCREENSAVER_IMAGE,
  filename: '',
  content_type: 'image'
}

export default class Station {

  readonly id: number
  readonly name: string
  displayName: string
  equipment: string[] = []
  defaultExerciseId: number | null
  layout: string
  side: string
  defaultFeedbackLevelKey: string
  defaultFeedbackVerbosity: string
  displayLocale: string
  allowAnonymousLogin: boolean

  position: number

  exercises: WorkoutExercise[] = []

  screensaverUrl: string
  audioHintsEnabled: boolean
  visualHintsEnabled: boolean
  exerciseTimeoutEnabled: boolean
  congratulationMessage: string
  stationType: '2d' | '3d'
  videoDisplayLocation: 'top' | 'bottom'

  screensaverProcessing: boolean = false

  constructor (attributes) {
    Object.assign(this, attributes)
    this.exercises = []
    this.equipment = this.equipment.filter(equipment => equipment && equipment !== '')
  }

  getScreensaver (): ScreensaverDTO {
    if (!this.screensaverUrl) {
      return DEFAULT_SCREENSAVER
    } else {
      return {
        content: this.screensaverUrl,
        filename: this.screensaverUrl.split('/')[this.screensaverUrl.split('/').length - 1],
        content_type: SUPPORTED_VIDEO_TYPES.includes(this.screensaverUrl.split('.')[this.screensaverUrl.split('.').length - 1]) ? 'video' : 'image'
      }
    }
  }
}
